import { useState } from 'react';

function MediaCardOne() {
  const [imgError, setImgError] = useState(false);
  return (
    <div className="group bg-background-50 rounded-xl border border-background-200/70 overflow-hidden hover:border-primary-200 transition-all duration-300 cursor-default">
      <div className="aspect-video bg-background-100 relative overflow-hidden">
        {!imgError ? (
          <img
            src="https://readdy.ai/api/search-image?query=Artistic%20manga%20style%20illustration%20of%20a%20Korean%20romance%20comic%20scene%20with%20soft%20pastel%20colors%2C%20two%20characters%20in%20elegant%20modern%20clothing%20under%20cherry%20blossoms%2C%20warm%20golden%20sunset%20lighting%2C%20dreamy%20atmospheric%20composition%2C%20clean%20minimalist%20background%2C%20soft%20bokeh%20effects&width=800&height=450&seq=media-card-01&orientation=landscape"
            alt="本周必看：韩漫完结精选"
            className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
            onError={() => setImgError(true)}
          />
        ) : (
          <div className="w-full h-full flex items-center justify-center text-foreground-400">
            <i className="ri-image-line text-4xl"></i>
          </div>
        )}
        <div className="absolute top-3 left-3">
          <span className="px-2.5 py-1 rounded-full bg-accent-500 text-background-50 text-xs font-medium">编辑推荐</span>
        </div>
      </div>
      <div className="p-4 md:p-5">
        <h3 className="text-sm md:text-base font-heading font-bold text-foreground-900 mb-2">本周必看：韩漫完结精选</h3>
        <p className="text-xs md:text-sm text-foreground-600 leading-relaxed">精选近期完结的高分韩漫推荐，包含恋爱、奇幻、悬疑等多种风格，部部精品不容错过，一口气看完完整版全集的绝佳选择。</p>
      </div>
    </div>
  );
}

function MediaCardTwo() {
  const [imgError, setImgError] = useState(false);
  return (
    <div className="group bg-background-50 rounded-xl border border-background-200/70 overflow-hidden hover:border-primary-200 transition-all duration-300 cursor-default">
      <div className="aspect-video bg-background-100 relative overflow-hidden">
        {!imgError ? (
          <img
            src="https://readdy.ai/api/search-image?query=Stylized%20anime%20illustration%20of%20action%20scene%20with%20dynamic%20composition%2C%20characters%20in%20motion%20with%20flowing%20hair%20and%20dramatic%20lighting%2C%20warm%20orange%20and%20golden%20color%20palette%2C%20Japanese%20anime%20aesthetic%2C%20clean%20background%20with%20speed%20lines&width=800&height=450&seq=media-card-02&orientation=landscape"
            alt="日漫新番：本季人气排行TOP10"
            className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
            onError={() => setImgError(true)}
          />
        ) : (
          <div className="w-full h-full flex items-center justify-center text-foreground-400">
            <i className="ri-image-line text-4xl"></i>
          </div>
        )}
        <div className="absolute top-3 left-3">
          <span className="px-2.5 py-1 rounded-full bg-accent-500 text-background-50 text-xs font-medium">人气排行</span>
        </div>
      </div>
      <div className="p-4 md:p-5">
        <h3 className="text-sm md:text-base font-heading font-bold text-foreground-900 mb-2">日漫新番：本季人气排行TOP10</h3>
        <p className="text-xs md:text-sm text-foreground-600 leading-relaxed">整理本季最受关注的日漫新番人气榜单，热血、奇幻、搞笑各类齐全，漫迷口碑佳作一网打尽，追番指南就看这篇。</p>
      </div>
    </div>
  );
}

function MediaCardThree() {
  const [imgError, setImgError] = useState(false);
  return (
    <div className="group bg-background-50 rounded-xl border border-background-200/70 overflow-hidden hover:border-primary-200 transition-all duration-300 cursor-default">
      <div className="aspect-video bg-background-100 relative overflow-hidden">
        {!imgError ? (
          <img
            src="https://readdy.ai/api/search-image?query=Elegant%20Chinese%20ink%20painting%20style%20illustration%20blending%20traditional%20and%20modern%20elements%2C%20ancient%20Chinese%20architecture%20with%20flowing%20silk%20ribbons%2C%20warm%20earthy%20tones%20with%20golden%20accents%2C%20atmospheric%20mist%20and%20soft%20lighting%2C%20artistic%20editorial%20composition&width=800&height=450&seq=media-card-03&orientation=landscape"
            alt="国漫崛起：不可错过的国产佳作"
            className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
            onError={() => setImgError(true)}
          />
        ) : (
          <div className="w-full h-full flex items-center justify-center text-foreground-400">
            <i className="ri-image-line text-4xl"></i>
          </div>
        )}
        <div className="absolute top-3 left-3">
          <span className="px-2.5 py-1 rounded-full bg-accent-500 text-background-50 text-xs font-medium">国漫推荐</span>
        </div>
      </div>
      <div className="p-4 md:p-5">
        <h3 className="text-sm md:text-base font-heading font-bold text-foreground-900 mb-2">国漫崛起：不可错过的国产佳作</h3>
        <p className="text-xs md:text-sm text-foreground-600 leading-relaxed">盘点近年国漫精品力作，从古风仙侠到现代都市，画风精美剧情扎实，见证国产漫画的飞速进步，支持国漫从阅读开始。</p>
      </div>
    </div>
  );
}

export default function MediaSection() {
  return (
    <section id="media" className="py-16 md:py-20 bg-background-50">
      <div className="px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">编辑精选</h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-[560px] mx-auto">编辑团队为你精选的漫画推荐专题，每周更新不容错过</p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          <MediaCardOne />
          <MediaCardTwo />
          <MediaCardThree />
        </div>
      </div>
    </section>
  );
}